export const styles = {
  container: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    alignSelf: 'center',
    width: ['95%', '95%', 560, 560, 560, 560],
    zIndex: 1,
    flexDirection: 'column',
    p: 10,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'backgroundPrimary',
    borderRadius: 'card',
    backdropFilter: 'blur(100px)',
    color: 'text'
  },
  heading: {
    fontSize: 5,
    fontWeight: 'normal',
    mb: 2
  },
  text: {
    fontSize: 1,
    color: 'text',
    textAlign: 'center',
    mb: 5
  },
  buttonsContainer: {
    flexDirection: [
      'column-reverse',
      'column-reverse',
      'column-reverse',
      'column-reverse',
      'row',
      'row'
    ],
    '& *:not(:last-child)': {
      mr: [0,0,0,0,2,2]
    }
  },
  backToChatButton: {
    mb: [8, 8, 8, 8, 0, 0]
  }
}

export default styles
